export default "__VITE_ASSET__D7t8zq_8__";